module.exports = __webpack_public_path__ + "img/c.c41aa85e.png";